import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// namespaces
import ns1 from './en/en.json';
import ns2 from './es/es.json';
import professionEn from './en/profession.json';
import professionEs from './es/profession.json';
import calendarEs from './es/calendar.json';
import calendarEn from './en/calendar.json';
import formErrorEn from './en/fromError.json';
import formErrorEs from './es/fromError.json';
import userValidationEs from './es/user-validation.json';
import userValidationEn from './en/user-validation.json';
import specialtiesEs from './es/specialties.json';
import specialtiesEn from './en/specialties.json';
import identificationsEs from './es/identifications.json';
import identificationsEn from './en/identifications.json';
import sessionCardEs from './es/session-card.json';
import sessionCardEn from './en/session-card.json';
import practitionerEn from './en/practitioner.json';
import practitionerEs from './es/practitioner.json';
import practitionerMenuEs from './es/practitioner-menu.json';
import practitionerMenuEn from './en/practitioner-menu.json';
import patientsEs from './es/patients.json';
import patientsEn from './en/patients.json';
import patientFileEn from './en/patient-file.json';
import patientFileEs from './es/patient-file.json';
import servicesEn from './en/services.json';
import servicesEs from './es/services.json';
import serviceSectionEn from './en/service-section.json';
import serviceSectionEs from './es/service-section.json';
import officesEn from './en/offices.json';
import officesEs from './es/offices.json';
import publicProfileEs from './es/publicProfile.json';
import publicProfileEn from './en/publicProfile.json';
import officeSectionEn from './en/officeSection.json';
import officeSectionEs from './es/officeSection.json';
import scheduleSectionEn from './en/sheduleSection.json';
import scheduleSectionEs from './es/sheduleSection.json';
import privateAccountEn from './en/private-account.json';
import privateAccountEs from './es/private-account.json';
import personalDataEn from './en/personal-data.json';
import personalDataEs from './es/personal-data.json';
import busisnessEn from './en/busisness.json';
import busisnessEs from './es/busisness.json';
import paymentEn from './en/payments.json';
import paymentEs from './es/payments.json';
import chargesEn from './en/charges.json';
import chargesEs from './es/charges.json';
import policiesEn from './en/policies.json';
import policiesEs from './es/policies.json';
import typeOrganizationEn from './en/typesOrganization.json';
import typeOrganizationEs from './es/typesOrganization.json';
import addressesEn from './en/addresses.json';
import addressesEs from './es/addresses.json';
import privateProfileEn from './en/privateProfile.json';
import privateProfileEs from './es/privateProfile.json';
import healthDataEn from './en/patient-healthdata.json';
import healthDataEs from './es/patient-healthdata.json';
import studiesEn from './en/studies.json';
import studiesEs from './es/studies.json';
import documentsEn from './en/documents.json';
import documentsEs from './es/documents.json';
import consultDetailsEn from './en/consult-details.json';
import consultDetailsEs from './es/consult-details.json';
import recordSummaryEn from './en/record-summary.json';
import recordSummaryEs from './es/record-summary.json';
import gendersEn from './en/genders.json';
import gendersEs from './es/genders.json';
import MyScheduleEn from './en/my-schedule.json';
import MyScheduleEs from './es/my-schedule.json';
import newDiagnosisEn from './en/new-diagnosis.json';
import newDiagnosisEs from './es/new-diagnosis.json';
import newTreatmentEn from './en/new-treatment.json';
import newTreatmentEs from './es/new-treatment.json';
import newWorkplanEn from './en/new-workplan.json';
import newWorkplanEs from './es/new-workplan.json';
import daysEn from './en/days.json';
import daysEs from './es/days.json';
import sectionsEn from './en/sections.json';
import sectionsEs from './es/sections.json';
import walkthroughEn from './en/walktrought.json';
import walkthroughEs from './es/walktrought.json';
import createAppointmentEn from './en/create-appointment.json';
import createAppointmentEs from './es/create-appointment.json';
import newPatientEn from './en/new-patient.json';
import newPatientEs from './es/new-patient.json';
import restrictedEn from './en/restricted.json';
import restrictedEs from './es/restricted.json';
import organizationEn from './en/organization.json';
import organizationEs from './es/organization.json';
import myDevicesEn from './en/my-devices.json'
import myDevicesEs from './es/my-devices.json'
import comingSoonEn from './en/comingsoon.json';
import comingSoonEs from './es/comingsoon.json';
import relationshipCatalogEn from './en/relationship-catalog.json';
import relationshipCatalogEs from './es/relationship-catalog.json';
import reportEs from './es/report.json'
import reportEn from './en/report.json'
import accessRolesEn from './en/access-roles.json';
import accessRolesEs from './es/access-roles.json';
import patientReportEn from './en/patientReport.json';
import patientReportEs from './es/patientReport.json';
import medicalhistoryEn from './en/medical-history.json';
import medicalhistoryEs from './es/medical-history.json';
import recordBackgroundEn from './en/recordBackground.json';
import recordBackgroundEs from './es/recordBackground.json';
import ethnizesEn from './en/ethnizes.json';
import ethnizesEs from './es/ethnizes.json';
import cancelAppointmentEn from './en/cancel-appointment.json';
import cancelAppointmentEs from './es/cancel-appointment.json';
import emailConfirmStatusEn from './en/email-confirm-status.json';
import emailConfirmStatusEs from './es/email-confirm-status.json';
import habitsEn from './en/habits.json';
import habitsEs from './es/habits.json';
import chatEn from './en/chat.json';
import chatEs from './es/chat.json'
import prognosisEn from './en/prognosis.json';
import prognosisEs from './es/prognosis.json';
import casesDataEn from './en/cases-data.json';
import casesDataEs from './es/cases-data.json';
import subscriptionEn from './en/subscription.json';
import subscriptionEs from './es/subscription.json'

import videocallEs from './es/videocall.json'
import videocallEn from './en/videocall.json'

import quizEs from './es/quiz.json'
import quizEn from './en/quiz.json'
import termsEs from './es/terms.json'
import termsEn from './en/terms.json'
import maritalStatusEs from './es/maritalStatus.json'
import maritalStatusEn from './en/maritalStatus.json'
import ordinalNumbersEs from './es/ordinal-numbers.json'
import ordinalNumbersEn from './en/ordinal-numbers.json'
import womanEs from './es/woman.json'
import womanEn from './en/woman.json'

import stripeEs from './es/stripe.json'
import stripeEn from './en/stripe.json'
import childEs from './es/child.json'
import childEn from './en/child.json'
import workplanEs from './es/workplan.json'
import workplanEn from './en/workplan.json'
import disabilitiesEs from './es/disabilities.json'
import disabilitiesEn from './en/disabilities.json'

import LanguageDetector from 'i18next-browser-languagedetector';
i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        interpolation: { escapeValue: false }, // React already does escaping
        // lng: 'en', // language to use
        // the resources are spliced into namespaces to reduce the file size and load time of the translations
        resources: {
            en: {
                common: ns1, // 'common' is our custom namespace
                profession: professionEn,
                address: addressesEn,
                calendar: calendarEn,
                userValidation: userValidationEn,
                specialties: specialtiesEn,
                identifications: identificationsEn,
                sessionCard: sessionCardEn,
                practitioner: practitionerEn,
                practitionerMenu: practitionerMenuEn,
                patients: patientsEn,
                patientFile: patientFileEn,
                formError: formErrorEn,
                offices: officesEn,
                services: servicesEn,
                serviceSection:serviceSectionEn,
                publicProfile: publicProfileEn,
                officeSection: officeSectionEn,
                scheduleSection: scheduleSectionEn,
                privateAccount: privateAccountEn,
                personalData: personalDataEn,
                busisness: busisnessEn,
                payments: paymentEn,
                charges: chargesEn,
                policies: policiesEn,
                orgTypes: typeOrganizationEn,
                privateProfile: privateProfileEn,
                healthData: healthDataEn,
                studies: studiesEn,
                docs: documentsEn,
                consultDetails: consultDetailsEn,
                genders: gendersEn,
                newDiagnosis: newDiagnosisEn,
                newTreatment: newTreatmentEn,
                mySchedule: MyScheduleEn,
                newWorkplan: newWorkplanEn,
                recordSummary: recordSummaryEn,
                days: daysEn,
                sections: sectionsEn,
                walkthrough: walkthroughEn,
                newAppointment: createAppointmentEn,
                newPatient: newPatientEn,
                restricted: restrictedEn,
                organization: organizationEn,
                myDevices: myDevicesEn,
                comingsoon: comingSoonEn,
                relationship: relationshipCatalogEn,
                accessRoles: accessRolesEn,
                report: reportEn,
                patientReport: patientReportEn,
                medicalHistory:medicalhistoryEn,
                recordBackground:recordBackgroundEn,
                ethnizes: ethnizesEn,
                cancelAppointment: cancelAppointmentEn,
                emailConfirmStatus: emailConfirmStatusEn,
                habits: habitsEn,
                chat: chatEn,
                prognosis: prognosisEn,
                casesData: casesDataEn,
                quiz: quizEn,
                subscription: subscriptionEn,
                terms: termsEn,
                videocall: videocallEn,
                maritalStatus: maritalStatusEn,
                ordinalNumbers: ordinalNumbersEn,
                woman: womanEn,
                stripe: stripeEn,
                child: childEn,
                workplan: workplanEn,
                disabilities: disabilitiesEn
            },
            es: {
                common: ns2,
                profession: professionEs,
                address: addressesEs,
                calendar: calendarEs,
                userValidation: userValidationEs,
                specialties: specialtiesEs,
                identifications: identificationsEs,
                sessionCard: sessionCardEs,
                practitioner: practitionerEs,
                practitionerMenu: practitionerMenuEs,
                patients: patientsEs,
                patientFile: patientFileEs,
                formError: formErrorEs,
                offices: officesEs,
                services: servicesEs,
                serviceSection:serviceSectionEs,
                publicProfile: publicProfileEs,
                officeSection: officeSectionEs,
                scheduleSection: scheduleSectionEs,
                privateAccount: privateAccountEs,
                personalData: personalDataEs,
                busisness: busisnessEs,
                payments: paymentEs,
                charges: chargesEs,
                policies: policiesEs,
                orgTypes: typeOrganizationEs,
                privateProfile: privateProfileEs,
                healthData: healthDataEs,
                studies: studiesEs,
                docs: documentsEs,
                consultDetails: consultDetailsEs,
                genders: gendersEs,
                newDiagnosis: newDiagnosisEs,
                newTreatment: newTreatmentEs,
                mySchedule: MyScheduleEs,
                newWorkplan: newWorkplanEs,
                recordSummary: recordSummaryEs,
                days: daysEs,
                sections: sectionsEs,
                walkthrough: walkthroughEs,
                newAppointment: createAppointmentEs,
                newPatient: newPatientEs,
                restricted: restrictedEs,
                organization: organizationEs,
                myDevices: myDevicesEs,
                comingsoon: comingSoonEs,
                relationship: relationshipCatalogEs,
                report: reportEs,
                accessRoles: accessRolesEs,
                patientReport: patientReportEs,
                medicalHistory:medicalhistoryEs,
                recordBackground:recordBackgroundEs,
                ethnizes: ethnizesEs,
                cancelAppointment: cancelAppointmentEs,
                emailConfirmStatus: emailConfirmStatusEs,
                habits: habitsEs,
                chat: chatEs,
                prognosis: prognosisEs,
                casesData: casesDataEs,
                quiz: quizEs,
                subscription: subscriptionEs,
                terms: termsEs,
                videocall: videocallEs,
                maritalStatus: maritalStatusEs,
                ordinalNumbers: ordinalNumbersEs,
                woman: womanEs,
                stripe: stripeEs,
                child: childEs,
                workplan: workplanEs,
                disabilities: disabilitiesEs
            },
        },
    });

export default i18n;
